import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import "../../assets/css/agent.scss";
import logoBlue from "../../assets/images/logo_blue.png";
import { useEffect, useState } from "react";
import { registerSubSalesMan } from "../../api/sales_man";
import { SessionStorageUtil } from "../../utils/session_storage_util";

function AgentRegisterPage() {
  const [searchParams] = useSearchParams();
  const kdBusiness = searchParams.get("kd_business");
  const navigate = useNavigate();
  const location = useLocation();

  const [formData, setFormData] = useState({
    id: "",
    name: "",
    phone: "010-0000-0000",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.id.trim()) {
      alert("아이디를 입력해주세요.");
      return;
    }

    if (!formData.name.trim()) {
      alert("이름을 입력해주세요.");
      return;
    }

    if (!formData.phone.trim()) {
      alert("휴대폰 번호가 필요합니다.");
      return;
    }

    const result = await registerSubSalesMan(
      kdBusiness,
      formData.id.trim(),
      formData.name.trim()
    );

    if (result.success) {
      navigate(`/agent/result?kd_business=${kdBusiness}`, {
        state: { salesManCode: result.data.salesManCode },
      });
    } else {
      alert(result.error.message);
    }
  };

  useEffect(() => {
    if (!kdBusiness || !SessionStorageUtil.getItem("accessToken")) {
      navigate(-1);
    }
  }, [kdBusiness]);

  useEffect(() => {
    if (location.state?.phoneNumber) {
      setFormData((prev) => ({
        ...prev,
        phone: location.state.phoneNumber,
      }));
    } else {
      alert("인증된 전화번호가 없습니다.");
      navigate(-1);
    }
  }, [location.state]);

  return (
    <div className="agent-container">
      <div className="agent-main">
        <div className="agent-content">
          <div className="logo-section">
            <div className="logo-text">
              <img src={logoBlue} alt="Logo" />
            </div>
          </div>

          <div className="register-form-section">
            <h1 className="form-title">에이전트 등록하기</h1>
            <p className="form-subtitle">에이전트 정보를 입력해주세요</p>

            <form className="register-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">아이디</label>
                <input
                  type="text"
                  name="id"
                  value={formData.id}
                  onChange={handleInputChange}
                  placeholder="아이디를 입력해주세요."
                  className="form-input"
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">이름</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="이름을 입력해주세요."
                  className="form-input"
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">휴대폰 번호</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  className="form-input phone-input"
                  readOnly
                  placeholder="인증된 번호가 자동으로 입력됩니다"
                />
              </div>

              <button type="submit" className="register-button">
                에이전트 등록하기
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AgentRegisterPage;
